import { RS_API_URI } from "@api/session";

import { queryString, sessionPrefix } from "./helpers";

export const mailsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/mails`;
export const newMailPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/mails/new`;

export const replyMailPath = (session: LightSessionInterface, mail: MailRef, qs: QueryStringType = null) =>
  `${sessionPrefix(session)}/mails/${mail.id}/reply${queryString(qs)}`;
export const forwardMailPath = (session: LightSessionInterface, mail: MailRef, qs: QueryStringType = null) =>
  `${sessionPrefix(session)}/mails/${mail.id}/forward${queryString(qs)}`;
export const editMailPath = (session: LightSessionInterface, mail: MailRef) =>
  `${sessionPrefix(session)}/mails/${mail.id}/edit`;

export const showMailAttachmentPath = (_session: LightSessionInterface, attachment: MailAttachmentRef) =>
  `${RS_API_URI}/mails/attachments/${attachment.id}`;

export function showMailPath(session: LightSessionInterface, thread: MailThreadRef, mail?: MailRef): string;
export function showMailPath(
  session: LightSessionInterface,
  thread: undefined,
  mail: Pick<Mail, "__typename" | "id" | "threadId">,
): string;

export function showMailPath(
  session: LightSessionInterface,
  thread: MailThreadRef | undefined,
  mail?: MailRef & { threadId?: string },
) {
  let path = `${sessionPrefix(session)}/mails/${thread?.id || mail?.threadId}`;

  if (mail) {
    path += `#mail-${mail.id}`;
  }

  return path;
}
